var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const loadImage = (url) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onerror = reject;
        img.onload = () => resolve(img);
        img.src = url;
    });
});
export function disposeImage(image) {
    if (!image) {
        return;
    }
    try {
        const parent = image.parentNode;
        if (parent) {
            parent.removeChild(image);
        }
    }
    catch (error) {
        /** noop */
    }
    image.onerror = null;
    image.onload = null;
    image.src = '';
    try {
        delete image.src;
    }
    catch (error) {
        /** noop */
    }
}
